/**
 * Проверка формата IMDB ID: tt + цифры (например, tt1234567).
 * Пустая строка считается допустимой — проверка обязательности выполняется отдельно.
 */
export function isValidImdbId(value: string): boolean {
    if (value === '') {
        return true;
    }

    return /^tt\d+$/.test(value);
}
